import { ca } from "date-fns/locale";
import React, { useState, useEffect } from "react";

const PlanTableCellSum = ({ existingRecipes, displayStats }) => {
    const [planCalories, setPlanCalories] = useState(0);
    const [planCarbs, setPlanCarbs] = useState(0);
    const [planFats, setPlanFats] = useState(0);
    const [planProteins, setPlanProteins] = useState(0);


    useEffect(() => {
        if (existingRecipes) {
            existingRecipes = existingRecipes.filter(recipe => recipe != null)
            mapPlanItems(existingRecipes)
        }
    }, [existingRecipes])

    const mapPlanItems = (meals) => {
        let calories = 0;
        let carbs = 0;
        let proteins = 0;
        let fats = 0;

        meals.forEach(meal => {
            meal.groceries.forEach(item => {
                calories += Number(item.ingredient.calories) * (Number(item.servingSize) / 100);
                carbs += Number(item.ingredient.carbohydrates) * (Number(item.servingSize) / 100);
                proteins += Number(item.ingredient.proteins) * (Number(item.servingSize) / 100);
                fats += Number(item.ingredient.fats) * (Number(item.servingSize) / 100);
            })

            meal.recipes.forEach(item => {
                if (item.servingSize && item.actualSize) {
                    calories += Number(item.calories) * (item.servingSize / item.actualSize);
                    carbs += Number(item.carbs) * (item.servingSize / item.actualSize);
                    proteins += Number(item.proteins) * (item.servingSize / item.actualSize);
                    fats += Number(item.fats) * (item.servingSize / item.actualSize);
                } else {
                    calories += Number(item.calories);
                    carbs += Number(item.carbs);
                    proteins += Number(item.proteins);
                    fats += Number(item.fats);
                }
            })

        })
        setPlanCalories(Number(calories).toFixed(2))
        setPlanCarbs(Number(carbs).toFixed(2))
        setPlanProteins(Number(proteins).toFixed(2))
        setPlanFats(Number(fats).toFixed(2))
    };

    return (
        displayStats ? <td className="relative  py-4 px-2 xl:px-4 font-xs text-xs font-semibold text-center  max-w-[120px] min-w-[120px] align-top">
            <div className="flex flex-col font-medium">
                <span >Kalorije - {Number(planCalories).toFixed(2)}</span>
                <span >Proteini - {Number(planProteins).toFixed(2)}</span>
                <span >Ugljeni hidrati - {Number(planCarbs).toFixed(2)}</span>
                <span >Masti - {Number(planFats).toFixed(2)}</span>
            </div>
        </td > : <td className="relative py-6 px-2 xl:px-4 font-xs text-xs max-w-[120px] min-w-[120px] align-top">
        </td >
    );
};

export default PlanTableCellSum;



